/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Ticketpageactions2Inputs */

const en_ticketpageactions2 = /** @type {(inputs: Ticketpageactions2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Actions for ${i?.name}`)
};

const de_ticketpageactions2 = /** @type {(inputs: Ticketpageactions2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aktionen für ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Actions for {name}" |
*
* @param {Ticketpageactions2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpageactions2 = /** @type {((inputs: Ticketpageactions2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpageactions2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpageactions2(inputs)
	return de_ticketpageactions2(inputs)
});
export { ticketpageactions2 as "ticketPageActions" }